<template>
<!-- 配置 -->
    <el-dialog
    v-model="props.isshowpz"
    title="添加企微主体"
    width="600px"
    :close-on-click-modal="false"
    @closed="closedpz"
  >
      <div style="width: 500px;margin: 0 auto;">
        <div class="t_pz_input">
          <div class="t_pz_title">企业 logo：</div>
          <el-upload
            :headers="headers"
            class="avatar-uploader"
            :action="upload_img"
            :data="upData"
            accept="image/jpg,image/jpeg,image/png"
            :show-file-list="false"
            :on-success="web_handleAvatarSuccess"
            :before-upload="web_beforeAvatarUpload">
            <img v-if="compfrom.corp_logo_url" :src="compfrom.corp_logo_url" class="avatar" />
                <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
            </el-upload>
            <div style="width: 306px;font-size: 13px;color: #777777;margin-left: 10px;">
                尺寸：200×200像素，图片大小不能超过2MB，支持jpg、jpeg、png格式
            </div>
        </div>
        <div class="t_pz_input">
          <div class="t_pz_title">主体名称：</div>
          <el-input  v-model="compfrom.corp_name" placeholder="请输入主体名称（易记即可）"  clearable />
        </div>
        <div class="t_pz_input">
          <div class="t_pz_title">企业微信ID：</div>
          <el-input v-model="compfrom.wx_corp_id"  placeholder="请输入微信ID"  clearable />
        </div>
        <div class="t_pz_input">
          <div class="t_pz_title">企业微信AgentID：</div>
          <el-input v-model="compfrom.agent_id"  placeholder="请输入AgentlID"  clearable />
        </div>
        <div class="t_pz_input">
          <div class="t_pz_title">企业微信密钥：</div>
          <el-input v-model="compfrom.corp_secret"  placeholder="请输入密钥"  clearable />
        </div>
        <div class="t_pz_input">
          <div class="t_pz_title">企业微信Token：</div>
          <el-input  v-model="compfrom.params_token" placeholder="请输入token"  clearable />
        </div>
        <div class="t_pz_input">
          <div class="t_pz_title">企业微信加密密钥：</div>
          <el-input  v-model="compfrom.encoding_aes_key" placeholder="请输入加密密钥"  clearable />
        </div>
        <div @click="web_openlink()" style="color:#2B4EFF;cursor: pointer;text-align: center;">
           了解如何获取企微配置信息
        </div>
        <div style="display: flex;justify-content: center;margin-top: 30px;">
          <el-button @click="addbus" color="#4F46E5" style="width: 100px;" type="primary">添加</el-button>
        </div>
      </div>
    </el-dialog>
</template>


<script setup>
import { ref, reactive,  provide, onBeforeMount, onMounted,watch } from 'vue'
import { ElMessage, ElMessageBox,UploadProps, UploadUserFile } from 'element-plus'
import { newaddcomp,neweditcomp,newgetcomplist } from '@/assets/js/common.js'

const headers = {
  'Authorization': 'Bearer ' + $cookies.get("fanstoken")
}

onMounted(() => {
    console.log('父级数据')
    console.log(props.fromtype)
    if(props.bjitem.data.id){
        compfrom.corp_id = props.bjitem.data.id
        compfrom.corp_logo_url = props.bjitem.data.corp_logo_url
        compfrom.corp_name = props.bjitem.data.corp_name
        compfrom.wx_corp_id = props.bjitem.data.wx_corp_id
        compfrom.agent_id = props.bjitem.data.agent_id
        compfrom.corp_secret = props.bjitem.data.corp_secret
        compfrom.params_token = props.bjitem.data.token
        compfrom.encoding_aes_key = props.bjitem.data.encoding_aes_key
    }else{
        compfrom.corp_id = ''
        compfrom.corp_logo_url = ''
        compfrom.corp_name = ''
        compfrom.wx_corp_id = ''
        compfrom.agent_id = ''
        compfrom.corp_secret = ''
        compfrom.params_token = ''
        compfrom.encoding_aes_key = ''
    }
    
})

// 接受父级数据，注册事件
const props = defineProps(['isshowpz','bjitem','fromtype'])
const emits = defineEmits(['addbus','closedpz'])

//新增数据
const compfrom = reactive({
  corp_id:'',
  corp_logo_url:'',
  corp_name:'',
  wx_corp_id:'',
  agent_id:'',
  corp_secret:'',
  params_token:'',
  encoding_aes_key:''
})





//确认添加
const addbus = ()=>{
  if(props.fromtype==2){
    neweditcomp(compfrom).then((response)=>{
            if (response.data.msg.code == 0) {
                    emits('addbus')
                ElMessage({
                    type: 'success',
                    message: '创建成功！',
                })
            }
        })
  }else if(props.fromtype==1){
    newaddcomp(compfrom).then((response)=>{
            if (response.data.msg.code == 0) {
                    emits('addbus')
                ElMessage({
                    type: 'success',
                    message: '创建成功！',
                })
            }
        })
  }
     
}

//关闭
const closedpz = ()=>{
    emits('closedpz')
}

const _urlfile = '/api/common/upload'
//上传图片地址
const upload_img = _urlfile

//网页缩略图
//回显地址
// const web_imgurl = ref('')
//上传返回参数
// const web_imgurl_result = ref('')

const upData=reactive(
  { file_type: '' }
)  // 上传文件data

//上传成功
const web_handleAvatarSuccess = (response,uploadFile)=>{
    
   
    compfrom.corp_logo_url = response.data.url
    // web_imgurl_result.value = response.result

    console.log('上传成功')
    console.log(response)
    console.log(compfrom.corp_logo_url)
}
//上传前检测
const web_beforeAvatarUpload = (rawFile)=>{
  
    if (rawFile.size / 1024 / 1024 > 2) {
    ElMessage.error('上传图片大小不能超过2MB!')
        return false
    }
    // upData.file = rawFile
    console.log('上传前检测')
    upData.file_type = 'image'
    return true
}

//打开网页
const web_openlink = ()=>{
    window.open(window.location.origin +  '/wenjian/企微配置参数说明.pdf','_blank')
}

   
</script>
<style scoped>
  
  .t_pz_input{
    display: flex;
    margin-bottom: 20px;
    align-items: center;
  }
  .t_pz_title{
    width: 200px;
    text-align: right;
  }
  .t_pz_inw{
    width: 300px;
  }
  :deep(.avatar-uploader .el-upload) {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

:deep(.avatar-uploader .el-upload:hover) {
  border-color: var(--el-color-primary);
}

:deep(.el-icon.avatar-uploader-icon) {
  font-size: 29px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  text-align: center;
}
  .avatar-uploader .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
</style>